import React, { useEffect, useState } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import enhancer from "./enhancer/EditProfileEnhancer";

import NavigationActions from "redux/navigation/actions";
import { getProfile, updateProfile } from "services/adminServices";
import Loader from "components/Loader";

const { success, error } = NavigationActions;

const EditProfile = (props, { titleStyle }) => {
  // console.log(props, "props")
  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    handleSubmit,
    isValid,
    token,
    setValues
  } = props;
  const [loading, setLoading] = useState(false);

  const getProfileData = async () => {
    setLoading(true);
    try {
      const profileRes = await getProfile(token);
      if (profileRes.success) {
        setValues({
          name: profileRes?.data?.name,
          email: profileRes?.data?.email,
          phone: profileRes?.data?.phone,
          address1: profileRes?.data?.address1,
          address2: profileRes?.data?.address2,
          city: profileRes?.data?.city,
          state: profileRes?.data?.state,
          pincode: profileRes?.data?.pincode
        });
      } else {
        error(profileRes.message);
      }
    } catch (error) {
      console.log("error while retrieving profile data", error);
    } finally {
      setLoading(false);
    }
  };

  const submitHandler = async e => {
    handleSubmit(e);
    if (isValid) {
      try {
        setLoading(true);

        const res = await updateProfile(token, values);
        if (res.success) {
          success(res.message);
          getProfileData();
        } else {
          error(res.message);
        }
      } catch (error) {
        console.log("error while editing profile>>>>>>>", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  useEffect(() => {
    getProfileData();
  }, []);

  return (
    <div className="container-fluid">
      <div className="work-card py-2">
        {/* <div className="Work-header" style={titleStyle}> */}
        <h4>Profile Information</h4>
        {/* </div> */}
        <div className="work-body mt-4">
          <form onSubmit={submitHandler}>
            <div className="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label>
                    Name <span className="red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control react-form-input"
                    id="name"
                    onChange={handleChange}
                    value={values.name}
                    onBlur={handleBlur}
                    placeholder="Enter Name"
                  />
                  <Error field="name" />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label>
                    Email <span className="red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control react-form-input"
                    id="email"
                    onChange={handleChange}
                    value={values.email}
                    onBlur={handleBlur}
                    placeholder="Enter Email"
                    disabled
                  />
                  <Error field="email" />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label>
                    Phone <span className="red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control react-form-input"
                    id="phone"
                    onChange={handleChange}
                    value={values.phone}
                    onBlur={handleBlur}
                    placeholder="Enter Phone"
                  />
                  <Error field="phone" />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label>
                    Address Line 1 <span className="red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control react-form-input"
                    id="address1"
                    onChange={handleChange}
                    value={values.address1}
                    onBlur={handleBlur}
                    placeholder="Address Line 1"
                  />
                  <Error field="address1" />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label>Address Line 2</label>
                  <input
                    type="text"
                    className="form-control react-form-input"
                    id="address2"
                    onChange={handleChange}
                    value={values.address2}
                    onBlur={handleBlur}
                    placeholder="Enter address line 2"
                  />
                  <Error field="address2" />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label>
                    City <span className="red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control react-form-input"
                    id="city"
                    onChange={handleChange}
                    value={values.city}
                    onBlur={handleBlur}
                    placeholder="Enter city"
                  />
                  <Error field="city" />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label>
                    State <span className="red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control react-form-input"
                    id="state"
                    onChange={handleChange}
                    value={values.state}
                    onBlur={handleBlur}
                    placeholder="Enter state"
                  />
                  <Error field="state" />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label>
                    Pincode <span className="red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control react-form-input"
                    id="pincode"
                    onChange={handleChange}
                    value={values.pincode}
                    onBlur={handleBlur}
                    placeholder="Enter pincode"
                  />
                  <Error field="pincode" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <button
                  type="submit"
                  className="c-primary btn btn-secondary float-right"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
        {loading && <Loader />}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken
  };
};

export default compose(
  // withRouter,
  enhancer,
  connect(mapStateToProps, { success, error })
)(EditProfile);
